import { checkAccess } from '@/core/helpers/auth.helper';
import { Scope, ScopeType } from '@/core/models/allowed-scopes.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { UserInfo } from './user-info.interface';
import { UserInfoService } from './user-info.service';

const service = new UserInfoService();

export interface UserInfoState {
   userInfo?: UserInfo;
   loadingUserInfo: boolean;
}

const UserInfoStore: Module<UserInfoState, StoreState> = {
   namespaced: true,
   state: { loadingUserInfo: true },
   getters: {
      userInfo: (state) => state.userInfo,

      hasTenantsViewPermission() {
         return checkAccess(ScopeType.Tenants, Scope.Update);
      },
   },
   mutations: {
      SET_USER_INFO(state, userInfo?: UserInfo) {
         state.userInfo = userInfo;
      },
      SET_LOADING_USER_INFO(state: UserInfoState, loading: boolean) {
         state.loadingUserInfo = loading;
      },
   },
   actions: {
      async getUserInfo(context, query?: LocationQuery) {
         context.commit('SET_LOADING_USER_INFO', true);

         return await service
            .getUserInfo(query)
            .then((userInfo) => {
               context.commit('SET_USER_INFO', userInfo);
               return userInfo;
            })
            .finally(() => {
               context.commit('SET_LOADING_USER_INFO', false);
            });
      },
   },
};

export default UserInfoStore;
